import {Component, Input, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import {BaseSectionComponent} from "../base-section/base-section.component";
import {PageTextImagesSection} from "../../../models/Page/Sections/PageTextImagesSection";
import {PageListPagesSection} from "../../../models/Page/Sections/PageListPagesSection";
import {TinyPostComponent} from "../../elements/tiny-post/tiny-post.component";
import {TinyPostFromIdPipe, TinyPostsFromIdsPipe} from "../../../pipes/tinyPostFromId/tiny-post-from-id.pipe";
import {WP_REST_API_Post, WP_Term} from "wp-types";
import {RouterLink} from "@angular/router";
import {WhenPageCategoriePipe} from "../../../pipes/when-page-categorie.pipe";
import {toggleTrigger} from "../../../trigger/toggle.trigger";

@Component({
  selector: 'list-pages-section',
  standalone: true,
  imports: [CommonModule, RouterLink, TinyPostComponent, TinyPostFromIdPipe, BaseSectionComponent, TinyPostsFromIdsPipe, WhenPageCategoriePipe],
  templateUrl: './list-pages-section.component.html',
  styleUrl: './list-pages-section.component.scss',
  animations: [
    toggleTrigger
  ],
})
export class ListPagesSectionComponent extends BaseSectionComponent<PageListPagesSection> implements OnInit{
  @Input() children: number[] = [];
  @Input() siblings: number[] = [];
  orderby : string = "include";
  filters : WP_Term[] = [];
  currentFilter?: number;
  initialized = false;

  override ngOnInit() {
    super.ngOnInit();
    if(typeof this.sectionRendered.pages === 'string'){
      this.sectionRendered.pages = [];
    }
    if(typeof this.sectionRendered.exclusions === 'string'){
      this.sectionRendered.exclusions = [];
    }
    if(this.sectionRendered.display_children && this.children?.length>0){
      this.sectionRendered.pages = this.sectionRendered.pages.concat(this.children);
      this.orderby = "title";
    }
    if(this.sectionRendered.display_siblings && this.siblings?.length>0){
      this.sectionRendered.pages = this.sectionRendered.pages.concat(this.siblings);
      this.orderby = "title";
    }
    if(this.sectionRendered.exclusions){
      this.sectionRendered.pages = this.sectionRendered.pages.filter((id)=>{
        return this.sectionRendered.exclusions.indexOf(id) < 0
      })
    }
  }

  onPageCategoriesChange(categories: WP_Term[]) {
    categories.forEach(category => {
      if (!this.filters.some(filterCategory => filterCategory.term_id === category.term_id)) {
        this.filters.push(category);
      }
    });
    if(this.filters.length>0 && this.sectionRendered.display_filters && !this.initialized){
      this.currentFilter = this.filters[0].term_id;
      this.initialized = true;
    }
  }

  onFilterClick(filter: WP_Term){
    this.currentFilter = filter.term_id;
  }
}
